$(document).ready(function() {
  
    const shopId = 43485921432;
    const customerId = checkAndSetCookie('__v__wl__c__');
    const url = `https://appsolve.io/bundle/api/v2/sf/ws?sid=${shopId}&cid=${customerId}`;

    function updateCounter(change) {
        let counter = $('.Vtl-WishlistHeader__HeartCounter');
        if (counter.length === 0) {
            counter = $('<span>').addClass('Vtl-WishlistHeader__HeartCounter').appendTo('.Vtl-WishlistHeader');
        }
        let count = parseInt(counter.text()) || 0;
        count += change;
        counter.text(count);
    }

    function handleResponse(data) {
        if (data) {
            data.forEach(function(wishlistItem) {
                $(`.wishlistBtnCollection[data-product="${wishlistItem.product.id}"]`).addClass('added-to-wishlist').attr('data-wid', wishlistItem.id);
            });
        } else {
            console.error('No products found in the response');
        }
    }

    function generateRandomString(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
  
    function checkAndSetCookie(cookieName) {
        var existingCookie = getCookie(cookieName);
        if (!existingCookie) {
            var uniqueValue = generateRandomString(20);
            document.cookie = cookieName + "=" + uniqueValue + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
            return uniqueValue;
        }
        return existingCookie;
    }
  
    if (customerId) {
        $.getJSON(url)
            .done(function(data) {
                handleResponse(data);
            })
            .fail(function(jqxhr, textStatus, error) {
                console.error('Failed to fetch products:', textStatus, error);
            });
    }

    function getCookie(cookieName) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(cookieName + '=')) {
                return cookie.substring(cookieName.length + 1);
            }
        }
        return null;
    }

    function sendPostRequest(url, data, callback) {
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function(response) {
                callback(null, response);
            },
            error: function(xhr, status, error) {
                callback(error || new Error('Failed to send request'));
            }
        });
    }

    $('.wishlistBtnCollection').click(function() {
        let productId = $(this).data('product');
        let variantId = $(this).data('variant');

        if (!customerId) {
            console.error('Customer ID not found in cookie');
            return;
        }

        let isAdded = $(this).hasClass('added-to-wishlist');
        const url = 'https://appsolve.io/bundle/api/v2/sf/ws';
        let requestData = {};

        if (!isAdded) {
            requestData = {
                shop_id: shopId,
                customerId: customerId,
                productId: productId,
                variantId: variantId
            };
            sendPostRequest(url, requestData, function(error, response) {
                if (error) {
                    console.error('Error:', error.message);
                } else {
                    if (!isAdded) {
                        $(`.wishlistBtnCollection[data-product="${productId}"]`).addClass('added-to-wishlist').attr('data-wid', response.id);
                        updateCounter(1);
                    }
                }
            });
        } else {
            let itemID = $(this).attr('data-wid');
            let $el = $(this);

            if (itemID) {
                let deleteURL = `https://appsolve.io/bundle/api/v2/sf/ws/${shopId}/${customerId}/${itemID}`;
                $.ajax({
                    url: deleteURL,
                    type: 'DELETE',
                    success: function(data) {
                        $el.removeClass('added-to-wishlist');
                        updateCounter(-1);
                    },
                    error: function(xhr, textStatus, error) {
                        console.error('Failed to remove item from wishlist:', textStatus, error);
                    }
                });
            }
        }
    });


  $(".add-to-cart").click(function() {
    var variant_id = $(this).data('variant-id');
    addItemToCart(variant_id, 1);
  });

  $(document).on('click','.filtersTrigger .CollectionToolbar__Item', function(){
      $('.filters-drawer').addClass('is-active');
      $('.filters-drawer').next().addClass('is-visible');
  });

  $(document).on('click','.filters-drawer .Drawer__Close, .filters-drawer + .PageOverlay', function(){
      $('.filters-drawer').removeClass('is-active');
      $('.filters-drawer').next().removeClass('is-visible');
  });

  function initShopTheLookSliders() {
    const customArrowPath = 'M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z';
    const isDraggable = window.innerWidth <= 1024;
    const options = {
      cellAlign: 'center',
      contain: false,
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true,
      groupCells: 1,
      setGallerySize: true,
      draggable: isDraggable,
      arrowShape: customArrowPath
    };

    const mainSlider = document.querySelector('.ShopTheLook-Wrapper.is-slider');
    let mmainSliderF = null;

    if (mainSlider && !mainSlider.classList.contains('flickity-enabled')) {
      mmainSliderF = new Flickity(mainSlider, options);

      setTimeout(() => {
        mmainSliderF.resize();
      }, 1000);
    }

    const rightSliders = [];

    document.querySelectorAll('.ShopTheLook').forEach(function (container) {
      const rightSlider = container.querySelector('.ShopTheLookRightSlider.is-slider');

      if (rightSlider && !rightSlider.classList.contains('flickity-enabled')) {
        const flktyRight = new Flickity(rightSlider, {
          cellAlign: 'left',
          contain: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: false,
          groupCells: 1,
          draggable: window.innerWidth <= 1024
        });

        rightSliders.push(flktyRight);

        container.querySelectorAll('.flickindex').forEach(function (dot) {
          dot.addEventListener('click', function () {
            const index = parseInt(dot.getAttribute('data-index'), 10) - 1;
            if (!isNaN(index)) {
              flktyRight.select(index);
            }
            container.querySelectorAll('.flickindex').forEach(function (d) {
              d.classList.remove('is-active');
            });
            dot.classList.add('is-active');
          });
        });

        setTimeout(() => {
          flktyRight.resize();
        }, 1000);
      }
    });

    // Handle zoom
    $(".btn.view_product-fancy").off('click').on('click', function () {
      $(".ShopTheLook-Section").addClass('is-zoomed');
      $(".ShopTheLook.is-selected").addClass('is-active');
      if (!$(".ShopTheLook.is-selected").length) {
        $(".ShopTheLook").addClass('is-active');
      }

      if (mmainSliderF) {
        mmainSliderF.destroy();
      }
      rightSliders.forEach(slider => slider.resize());
    });

    // Handle close
    $("button.ShopTheLookRightCross").off('click').on('click', function () {
      $(".ShopTheLook-Section").removeClass('is-zoomed');
      $(".ShopTheLook").removeClass('is-active');

      if (!mainSlider.classList.contains('flickity-enabled')) {
        mmainSliderF = new Flickity(mainSlider, options);
      }
    });
  }

  // Run on first load
  initShopTheLookSliders();

  // Hook into Shopify theme editor reloads
  document.addEventListener('shopify:section:load', initShopTheLookSliders);



  function addItemToCart(variant_id, qty) {
      var data = {
          "id": variant_id,
          "quantity": qty
      };
      jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() {
              document.dispatchEvent(new CustomEvent('cart:build'));
              $('body').trigger('added.ajaxProduct');
          }
      });
  }

  
  let filters = [];
  let productsContainer = '.grid--collection';
  $(document).on('change','.filters-drawer [type="checkbox"]', function(){    
      filters = [];
      $('.filters-drawer [type="checkbox"]:checked').each(function(){
          let name =  $(this).attr('name');
          let val = $(this).val();
          let filter = name+'='+val;
          filters.push(filter);
      });
    
      let url = makeURL(filters);
    
      getAjaxContent(url).done(function(response) {

        let $content = $('<div>').html(response);
        let $productsContainerContent = $content.find(productsContainer).html();
        let $products = $content.find('.grid-product');
        
        if ($products.length > 0) {
            $(productsContainer).html($productsContainerContent);
        } else {
            $(productsContainer).html('<p>No products found.</p>');
        }
        
        history.pushState({}, '', url);
        
      }).fail(function(xhr, status, error) {
        
        console.error('Error occurred while fetching content:', error);
        
      });
    
  });
  
  function makeURL(filters){
    
      if(filters == []){
         url = window.location.origin+window.location.pathname;
         return url;
      }
    
      let exURL = window.location.href;
      let ifSort = exURL.split('?sort_by=');
      let sortTag = 0;
      let url = window.location.origin+window.location.pathname;
    
      if(ifSort.length > 1){
          sortTag = ifSort[1];
      }
    
      if(sortTag != 0){
          url = url + '?' +filters.join('&')+'&sort_by='+sortTag;
      }else{
          url = url + '?' +filters.join('&');
      }
    
      return url;
  }
  
  function getAjaxContent(url) {
      return $.ajax({
          url: url,
          type: 'GET',
          dataType: 'html'
      });
  }
  
});

function initializeVideoSlider() {
    function initVideoSlider() {
        const $slider = $(".video-images-slides");
        if (!$slider.hasClass("slick-initialized")) {
            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                autoplay: false,
                infinite: true,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 490,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    }
    $(document).ready(function () {
        initVideoSlider();
        $(window).off("resize.videoSlider").on("resize.videoSlider", initVideoSlider);
    });
}

// Initialize on page load and Shopify section load
document.addEventListener("DOMContentLoaded", function () {
    initializeVideoSlider();
});

document.addEventListener("shopify:section:load", function () {
    initializeVideoSlider();
});

document.querySelectorAll(".video-image-slide .playpausebtn").forEach(function(button) {
    button.addEventListener("click", function() {
        const parentSlide = this.closest(".video-image-slide");
        const video = parentSlide.querySelector("video");

        if (video.paused) {
            video.play();
            parentSlide.classList.remove("is-paused");
        } else {
            video.pause();
            parentSlide.classList.add("is-paused");
        }
    });
});

